import { contentTable, index, text } from "@-/dev.improve.haniverse.lib.database.table";

export const appWordPronunciationCardTable = contentTable(
  "app_word_pronunciation_card",
  {
    word: text("word").notNull(),
  },
  (table) => [index("app_word_pronunciation_card_word_idx").on(table.word)],
);

export type AppWordPronunciationCard = typeof appWordPronunciationCardTable.$inferSelect;
